export default {
  loading: "拼命加載中",
  totalData: "條數據",
  totalPrefix: "共計",
  startDate: "開始日期",
  endDate: "結束日期",
  reset: "重置",
  search: "查詢",
  loadMore: "加載更多數據",
  loadCompleted: "已全部加載完成",
  collapse: "收起",
  noData: "暫無數據",
  directions: {
    withdraw: "提現",
    deposit: "充值",
    buy: "買入",
    sell: "賣出",
    unknown: "未知",
  },
  common: {
    noBank: "暫無查詢到相關銀行",
  },
};
